import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private language: string = 'vi'; // Mặc định là 'vi' (Tiếng Việt).
  private languageSet: boolean = false;
  private languagePromise: Promise<void>;
  private languageResolve: () => void;

  constructor() {
    this.languagePromise = new Promise<void>(resolve => {
      this.languageResolve = resolve;
    });
  }

  setLanguage(language: string) {
    this.language = language;
    this.languageSet = true;
    this.languageResolve();
  }

  getLanguage(): string {
    return this.language;
  }

  isLanguageSet(): boolean {
    return this.languageSet;
  }

  getLanguagePromise(): Promise<void> {
    return this.languagePromise;
  }
}
